import { Directive, ElementRef, inject, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ImageSrcService } from './image-src.service';

/**
 * Usage:
 * <img
 *    [appImgSrc]="'http://path_to_my_image'" // Set path to image
 *    src="./some_default_image.png" // Set default src if needed
 *    height=50 // Set all standard attributes you need
 *    width=50
 * />
 */
@Directive({
  selector: '[appImgSrc]'
})
export class ImageSrcDirective implements OnInit {
  @Input()
  public appImgSrc: string | undefined;

  @Input()
  public enableCache: boolean = false;

  private image = new BehaviorSubject<string>('');
  private el: ElementRef;
  private imageSrcService: ImageSrcService;

  constructor() {
    this.el = inject(ElementRef);
    this.imageSrcService = inject(ImageSrcService);

    this.image
      .pipe(
        filter(Boolean)
      )
      .subscribe(src => (this.el.nativeElement.src = src));
  }

  public ngOnInit(): void {
    this.loadImage();
  }

  private loadImage(): void {
    if (!this.appImgSrc) {
      return;
    }

    this.imageSrcService.loadImage(this.appImgSrc, this.enableCache)
      .subscribe(
        binary => this.image.next(binary),
      );
  }
}
